import React from 'react';

export const HelpIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <circle
                    cx="2.91"
                    cy="2.91"
                    r="2.381"
                    fill="none"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeWidth="0.529"
                ></circle>
                <g
                    aria-label="?"
                    style={{ lineHeight: '1.25' }}
                    strokeWidth="0.265"
                    fontFamily="sans-serif"
                    fontSize="3.881"
                >
                    <path
                        d="M3.136 3.597h-.483L2.65 3.47q0-.235.078-.386.077-.152.31-.341.233-.19.279-.248.07-.093.07-.205 0-.156-.125-.265-.123-.112-.334-.112-.202 0-.339.115-.136.116-.187.353l-.49-.06q.022-.34.289-.577.269-.237.705-.237.458 0 .73.241.27.239.27.557 0 .176-.1.334-.099.157-.425.428-.168.14-.21.225-.04.085-.036.305zm-.483.717V3.78h.532v.533z"
                        style={{}}
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.265"
                        fontFamily="Arial"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
